import React, {useEffect, useState} from 'react';
import { getServitorCompany} from "../api/HomeApi";
import {showError} from "../../../utils/toastHelper";
import {MdOutlineLocalOffer} from "react-icons/md";
import {TiChevronLeftOutline} from "react-icons/ti";
import {useNavigate} from "react-router-dom";

const Services = () => {
    const [services, setServices] = useState([]);

    const navigate = useNavigate();
    useEffect(() => {
        const fetchServices = async () => {
            try {

                const params = {
                    special : 1
                }
                const data = await getServitorCompany(localStorage.getItem('_vid'), params);
                setServices(data?.data.services );
            } catch (err) {
                showError( err);
            } finally {

            }
        };
        fetchServices();
    }, []);



    return (
        <React.Fragment>
            <section className="container  mt-1 py-3 rtl px-0  ">
                <div className="row mx-1">
                    <div className="col-8 home-separator-text ">
                        <MdOutlineLocalOffer className='mx-2'/>

                        پیشنهادهای ویژه
                    </div>
                    <div className="col-4 text-start text-small-3 text-secondary-color mt-1"

                         onClick={() => navigate('/services?special=1')}
                    >
                        مشاهده همه
                        <TiChevronLeftOutline className='mx-1'/>
                    </div>
                </div>
                <div className="row ms-3 me-2 pb-5 mb-3">
                    {
                        services.map((service, index) => {
                            return (

                                <div className="col-12 col-md-6 px-1 mt-2 service-card"
                                     onClick={
                                         () => {
                                             navigate(`/service/${service.id}`);
                                         }
                                     }
                                     key={service.id}
                                >
                                    <div className="card">
                                        <div className="row m-1 ">
                                            <div className="col-2 text-center p-0 "
                                            >
                                                <img src={service.image} alt={service.title} className='w-100'/>

                                            </div>
                                            <div className="col-10 text-end text-small-1 fw-bold pt-2 ">
                                                {service.title}
                                                <div className='text-justify text-small-3 text-muted mt-2 '>
                                                    {service.brief.substring(0, 55)}...

                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </section>
        </React.Fragment>

    );
};

export default Services;
